export default {
    namespaced: true,
    state: {
        isAutoBroadcast: false, // 是否自动播报
        isVoiceCall: false, // 是否语音通话
        isVoicePlayer: false, // 播报状态
    },
    mutations: {
        setAutoBroadcast(state, isAutoBroadcast) {
            state.isAutoBroadcast = isAutoBroadcast;
        },
        setVoiceCall(state,isVoiceCall) {
            state.isVoiceCall = isVoiceCall;
        },
        setVoicePlayer(state,isVoicePlayer) {
            state.isVoicePlayer = isVoicePlayer;
        }
    },
};